<app-loader *ngIf="isLoading"></app-loader>

<section class="pwa-header-control">
    <div class="pwa-header-control__logo-wrapper">
        <img nwnCdnClient="header-logo.png" alt="Main logo" class="pwa-header-control__client-logo">
    </div>
    <div class="pwa-header-control__items">
        <button *ngIf="!(name | async)"
                class="btn primary-btn pwa-header-control__icon-button"
                role="button"
                aria-label="Sign in"
                data-testid="7616C2F8-179F-43E1-BC7E-C2371165425A">
            <i class="fa fa-sign-in" aria-hidden="true"></i>
        </button>
        <div *ngIf="name | async" class="dropdown app-dropdown pwa-header-control__menu" [ngClass]="{ 'open': dropdownOpen }">
            <button id="navigation-dropdown"
                    type="button"
                    data-toggle="dropdown"
                    (click)="toggleDropdown($event)"
                    class="btn primary-btn dropdown-toggle pwa-header-control__dropdown-button"
                    aria-haspopup="menu"
                    aria-label="User menu"
                    aria-controls="user-menu"
                    [attr.aria-expanded]="dropdownOpen"
                    data-testid="2DBC5598-CE6F-49FC-B58E-0CAA59407DBE">
                <span class="pwa-header-control__user-name">
                    {{ name | async }}
                </span>
                <i class="fa fa-solid fa-chevron-down" aria-hidden="true"></i>
            </button>
            <div *ngIf="dropdownOpen" (click)="toggleDropdown($event)" class="dropdown-backdrop"></div>
            <ul class="dropdown-menu" role="menu" id="user-menu" aria-labelledby="navigation-dropdown">
                <li role="none">
                    <button data-testid="F9D8B5A6-4D10-4146-BFE4-A9F20D1CBE77" (click)="onLogoutButtonClicked()" class="btn btn-delete pwa-header-control__menu-option" type="button" role="menuitem">
                        <i class="fa fa-sign-out" aria-hidden="true"></i>
                        {{ 'MasterNavigationBarLogout' | smartlabel | async }}
                    </button>
                </li>
            </ul>
        </div>
    </div>
</section>

<div class="bg-danger offline-header" *ngIf="!isOnline">
    <i class="fa fa-solid fa-signal-slash" aria-hidden="true"></i>
    {{ 'MasterHeaderApplicationOffline' | smartlabel | async }}
</div>

<main class="content-box"
      [ngClass]="{ offline: !isOnline }">
    <router-outlet></router-outlet>
</main>

<footer>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-4 col-sm-4">
                <div class="footer-logo">
                    <img nwnCdnClient="footer-logo.png"
                         alt="Footer logo" />
                </div>

                <span
                      [innerHTML]="'MasterFooterCopyright' | smartlabel: { replacements: { 'YEAR': copyrightYear } } | async">
                </span>

                <div *ngIf="'MasterFooterInfo' | smartlabel | async as labelText"
                     class="footer-info"
                     [innerHTML]="labelText"></div>
            </div>

            <div class="col-md-6 col-sm-6">
                <div class="footer-links"
                     [innerHTML]="'MasterFooterLinks' | smartlabel | async"></div>
            </div>

            <div class="col-md-2 right-align-txt col-sm-2">
                <div class="footer-logo">
                    <img nwnCdnClient="insight-footer-logo.png"
                         alt="Insight footer logo" />
                </div>
            </div>
        </div>
    </div>
</footer>
